import { lazy, type LazyExoticComponent } from 'react';

import type { ActionKeys } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { ActionRendererFor } from '@atlassian/conversation-assistant-message-actions-api/types';

export const ImageSearchActionAsync: LazyExoticComponent<
	(props: ActionRendererFor<typeof ActionKeys.ImageSearch>) => React.JSX.Element | null
> = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-message-actions/image-search-action" */ './image-search-action'
	).then((m) => ({ default: m.ImageSearchAction })),
);
